import { render } from "./spaceSize.vue?vue&type=template&id=43575418&scoped=true"
import script from "./spaceSize.vue?vue&type=script&lang=js"
export * from "./spaceSize.vue?vue&type=script&lang=js"

import "../../less/profileSettings.less?vue&type=style&index=0&id=43575418&scoped=true&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43575418"]])

export default __exports__